module.exports = __webpack_public_path__ + "img/chat-square-quote-fill.b360a3d1.svg";